module.exports = __webpack_public_path__ + "img/accordian_up_arrow.98164233.svg";